var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLeftArrowWhite = function SvgLeftArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.398,
    cy: 20,
    r: 19.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.705 14.615 17.32 20l5.385 5.384",
    stroke: "#fff"
  })));
};

export { SvgLeftArrowWhite as ReactComponent };
export default __webpack_public_path__ + "c162a31f1623cc8b5459e846e1249d97.svg";